import { tv } from '@change/ds-utils';

export const FooterStyles = tv({
	base: 'flex flex-col items-center justify-start whitespace-pre-line bg-background-base font-[Arial] font-normal leading-[140%] tracking-[0%]',
	compoundVariants: [
		{
			size: 'large',
			loading: true,
			className: 'gap-[23px] px-[11px] py-4',
		},
		{
			size: 'medium',
			loading: true,
			className: 'gap-[22px] px-2.5 py-3',
		},
		{
			size: 'small',
			loading: true,
			className: 'gap-4 p-[5px] pt-1',
		},
		{
			size: 'large',
			loading: false,
			className: 'p-3',
		},
		{
			size: 'medium',
			loading: false,
			className: 'mb-3 p-2.5 pb-0 pt-2',
		},
		{
			size: 'small',
			loading: false,
			className: 'p-[5px] pb-1',
		},
	],
	variants: {
		size: {
			xsmall: '',
			small: 'line-clamp-[11] text-[4.25px]',
			medium: 'line-clamp-[11] text-[8.2px]',
			large: 'line-clamp-[11] text-[9.5px]',
		},
		loading: {
			true: '',
			false: '',
		},
	},
});
